const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'] as const;
const SIZE_UNIT_MB = 1024 * 1024;
const SIZE_UNIT_KB = 1024;

export function formatBytes(value: number | null | undefined, locale = 'en-CH') {
  if (value === null || value === undefined) return '-';

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return String(value);
  if (numericValue === 0) return '0 B';

  const absoluteValue = Math.abs(numericValue);
  const unitIndex = Math.min(Math.floor(Math.log(absoluteValue) / Math.log(1000)), BYTE_UNITS.length - 1);
  const scaledValue = numericValue / 1000 ** unitIndex;
  const maximumFractionDigits = scaledValue >= 100 || unitIndex === 0 ? 0 : scaledValue >= 10 ? 1 : 2;

  return `${scaledValue.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits,
  })} ${BYTE_UNITS[unitIndex]}`;
}

export function formatBytesToMbLabel(bytes?: number | null) {
  if (!Number.isFinite(bytes) || bytes == null || bytes <= 0) {
    return null;
  }

  const sizeInMb = bytes / SIZE_UNIT_MB;
  if (sizeInMb < 0.1) {
    return `${Number((bytes / SIZE_UNIT_KB).toFixed(1))}KB`;
  }
  return `${Number(sizeInMb.toFixed(1))}MB`;
}
